/** Utilities */
import { useEffect, useRef, useState } from "react";
/** Common Components */
import CardSection from "../../../components/ui/card/CardSection";
import MolGrid from "../../../components/grid/MolGrid";
/** Configuration Files */
import { SourceControlGridConfig } from "./config/SourceControl.data";
/** RTK Query */
import { useLazyGetAllSourceControlListQuery } from "../../../app/services/commonAPI";

const SourceControl = () => {
    const molGridRef = useRef();
    const [listData, setListData] = useState([])

    //** API Call's */
    const [getAllSourceControlList, { isFetching: isGetAllSourceControlListFetching, isSuccess: isGetAllSourceControlListSuccess, data: getAllSourceControlListData },] = useLazyGetAllSourceControlListQuery();

    /* UseEffect **/
    useEffect(() => {
        getAllSourceControlList();
    }, [getAllSourceControlList])

    useEffect(() => {
        if (isGetAllSourceControlListSuccess && getAllSourceControlListData) {

            if (getAllSourceControlListData) {
                setListData(getAllSourceControlListData);
            }
        }
    }, [isGetAllSourceControlListSuccess, getAllSourceControlListData]);

    return (
        <div className="source-control-list center-top-space">
            <CardSection cardTitle={"Source Control List"}>
                <div className="table-grid">
                    <MolGrid
                        ref={molGridRef}
                        configuration={SourceControlGridConfig}
                        dataSource={listData}
                        allowPagination={false}
                        isLoading={isGetAllSourceControlListFetching}

                    />
                </div>
            </CardSection>
        </div>
    );
}
export default SourceControl;